import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { AdminServiceContext } from '../../services/AdminService';
import LoadingMarkUp from '../../components/Loading/Loading';
import InputComponent from '../../components/Input/InputComponent';
import AppButton from '../../components/AppButton/AppButton';
import InputFilePdfComponent from '../../components/Input/InputFilePdfComponent';

const PriceListGroup = ({ handleCloseDialog }) => {
  const {
    priceListGroup,
    getPriceListGroupById,
    addPriceListGroup,
    updatePriceListGroup,
    error,
    success,
  } = useContext(AdminServiceContext);
  const { t, i18n } = useTranslation();
  //console.log(getReviews);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    id: null,
    name: '',
    fileUrl: '',
  });

  const lang = i18n.language || 'en';
  const { priceListGroupId } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      const langModel = {
        id: priceListGroupId,
        languageCode: lang,
      };
      await getPriceListGroupById(priceListGroupId);
      setLoading(false);
    };

    if (priceListGroupId) {
      fetchData();
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (priceListGroup) {
      if (!priceListGroupId) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          id: null,
          name: '',
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          id: priceListGroup.id,
          name: priceListGroup.name,
        }));
      }
    }
  }, [priceListGroup]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    if (priceListGroupId) {
      await updatePriceListGroup(formData);
    } else {
      await addPriceListGroup(formData);
    }

    if (success) {
      setFormData({
        id: -1,
        name: '',
      });
      handleCloseDialog();
    }
    setLoading(false);
  };

  const handleFileChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      fileUrl: e,
    }));
  };

  if (loading) {
    return <LoadingMarkUp />;
  }

  return (
    <>
      <h2>PriceListGroup Id:{priceListGroupId}</h2>
      <form onSubmit={handleSubmit}>
        <InputComponent
          label="priceListGroupname"
          type="text"
          id="name"
          required={true}
          name="name"
          value={formData.name}
          onChange={(e) => handleInputChange(e)}
        />
        <InputFilePdfComponent
          label="File"
          type="file"
          id="MainImage"
          name="MainImage"
          multiple={false}
          required={false}
          onFileSelected={handleFileChange}
        />
        {error ? error : null}
        <div className="form-group row"></div>
        <div className="form-group row"></div>
        <div className="form-group row">
          <AppButton type={'submit'} full label="submit" />
        </div>
      </form>
    </>
  );
};

export default PriceListGroup;
